import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React, { useMemo } from 'react'
import { useTable } from 'react-table'

const AdxTableComponent = ({
  data,
  column,
  stickyHeader,
  nav,
  onClick,
  sx,
  sxHeader,
  sxCell,
  sxNav,
  rowOnClick,
  ...rest
}) => {
  const tableHeader = useMemo(() => column, [column])
  const tableInstance = useTable({
    columns: tableHeader,
    data: data,
  })
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance
  return (
    <TableContainer
      sx={{
        backgroundColor: 'white.main',
        borderRadius: 0,
        boxShadow: 'none',
        '& th.MuiTableCell-root': {
          padding: '13.5px 30px',
        },
        '& td.MuiTableCell-root': {
          padding: '0px',
        },
        ...sx,
      }}
      {...rest}
    >
      <Table stickyHeader={stickyHeader} {...getTableProps}>
        <TableHead>
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <TableCell align="center" {...column.getHeaderProps()}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: 'light-gray-text.main',
                      textAlign: index === 0 && 'left',
                      ...sxHeader,
                    }}
                  >
                    {column.render('Header')}
                  </Typography>
                </TableCell>
              ))}
              {nav && (
                <TableCell>
                  <Typography></Typography>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row)
            return (
              <TableRow
                {...row.getRowProps()}
                sx={{
                  ...(rowOnClick && {
                    cursor: 'pointer',
                    backgroundColor: 'white.main',
                    '&:hover': { backgroundColor: 'gray-background.main' },
                  }),
                }}
                onClick={() => (rowOnClick ? rowOnClick(row.original) : null)}
              >
                {row.cells.map((cell, index) => {
                  return (
                    <TableCell
                      sx={{
                        ...sxCell,
                      }}
                      align="center"
                      {...cell.getCellProps()}
                    >
                      <Typography
                        sx={{
                          textAlign: index === 0 && 'left',
                          padding: '18px 30px',
                        }}
                      >
                        {cell.render('Cell')}
                      </Typography>
                    </TableCell>
                  )
                })}
                {nav && (
                  <TableCell align="right">
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: 'alternate.main',
                        cursor: 'pointer',
                        padding: '18px 30px',
                        ...sxNav,
                      }}
                      onClick={() => onClick(row.original)}
                    >
                      {nav}
                    </Typography>
                  </TableCell>
                )}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default AdxTableComponent
